<script>
  const { span = 1, children } = $props();
</script>

<div class="info-box" style={span > 1 ? `grid-column: span ${span}` : ''}>
  {@render children?.()}
</div>

<style>
  .info-box {
    padding: var(--spacing-8);
    background: var(--color-gray-shade-lightest);
    min-width: 0;
  }
</style>
